import { render } from "./NoEvents.vue?vue&type=template&id=2fd1fd70&scoped=true"
import script from "./NoEvents.vue?vue&type=script&lang=js"
export * from "./NoEvents.vue?vue&type=script&lang=js"

import "./NoEvents.vue?vue&type=style&index=0&id=2fd1fd70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd1fd70"]])

export default __exports__